
import { Component, Prop, Vue } from 'vue-property-decorator';
import HokCheckbox from '@hokify/shared-components/lib/components/HokCheckbox.vue';
import type { ISelectedFilter } from '~/store/types';

@Component({
	name: 'JobFilterDesktop',
	components: {
		HokCheckbox
	}
})
export default class JobFilterDesktop extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) readonly showIcon!: boolean;

	@Prop({ type: Boolean, default: false }) readonly isExpanded!: boolean;

	@Prop({ type: Number }) readonly index!: number;

	@Prop({ type: String, required: true }) readonly category!: string;

	@Prop({ type: Array, required: true }) readonly filters!: ISelectedFilter[];

	@Prop({ type: Array, required: true }) readonly selectedFilters!: ISelectedFilter[];

	get selectedFiltersOfCategory(): number {
		return this.selectedFilters.filter(a => !!this.filters.find(b => a.filter === b.filter)).length;
	}

	handleCheckboxChange(filter: ISelectedFilter) {
		this.$emit('change', filter);
		this.$emit('expand', this.index);
	}
}
